import { createTransportLogger, MessageDirection, wrap } from "./shared";
const log = createTransportLogger("Android");
export const buildAndroidTransport = ()=>{
    return new AndroidTransport();
};
class AndroidTransport {
    postMessage(messages) {
        log.debug("Attempting to send messages", messages);
        //@ts-ignore
        if (typeof SWAndroid !== "undefined") {
            const wrappedOutgoingMessage = wrap(messages, MessageDirection.FromPaywall);
            log.debug("Wrapped message for transport", wrappedOutgoingMessage);
            //@ts-ignore
            SWAndroid.postMessage(wrappedOutgoingMessage);
            log.info("Sent message via SWAndroid interface");
            return;
        }
        log.warn("Unable to send message - SWAndroid interface not available");
    }
    _handlers = [];
    addListener(handler) {
        this._handlers.push(handler);
    }
    _listening = false;
    startListening() {
        this._listening = true;
    }
    accept(message) {
        if (this._listening) {
            this._handlers.forEach((handler)=>handler(message));
        }
    }
}
